import { HandCoins } from "lucide-react";
import { formatEuro } from "../lib/format";

// Riepilogo informativo delle spettanze del segnalatore calcolate sulle quietanze della pratica.
const quotaOf = (seg, q) => {
  const pct = Number((String(seg.compenso_percentuale || "").match(/\d+(?:[.,]\d+)?/) || ["0"])[0].replace(",", "."));
  if (!pct || pct <= 0) return null;
  const b = seg.compenso_base;
  if (b === "sugli onorari") return ((Number(q.onorari) || 0) - (Number(q.spese_studio) || 0)) * pct / 100;
  if (b === "sul risarcimento" || b === "sul danno") return (Number(q.sorte_capitale) || 0) * pct / 100;
  return null;
};

export const SpettanzeSegnalatore = ({ segnalatore, segRec, rows }) => {
  if (!segnalatore) return null;
  const tipo = segRec?.compenso_tipo || "fisso";
  let body;
  if (!segRec) body = <span className="text-slate-400">Compenso non impostato in Anagrafica: impossibile calcolare le spettanze.</span>;
  else if (tipo !== "percentuale") {
    body = <span>Compenso fisso: <strong className="font-mono text-amber-300" data-testid="spettanze-fisso">{formatEuro(Number(String(segRec.compenso_importo || 0).replace(",", ".")) || 0)}</strong></span>;
  } else {
    const quote = rows.map((q) => ({ q, v: quotaOf(segRec, q) }));
    if (quote.every((x) => x.v === null)) body = <span className="text-slate-400">Base di calcolo del compenso non impostata in Anagrafica.</span>;
    else {
      const ricevute = quote.filter((x) => x.q.onorari_ricevuti).reduce((s, x) => s + (x.v || 0), 0);
      const totali = quote.reduce((s, x) => s + (x.v || 0), 0);
      body = (
        <div className="flex flex-wrap gap-x-6 gap-y-1">
          <span>{segRec.compenso_percentuale}% {segRec.compenso_base}</span>
          <span>Maturate (onorari ricevuti): <strong className="font-mono text-emerald-400" data-testid="spettanze-maturate">{formatEuro(ricevute)}</strong></span>
          <span>Previste su tutte le quietanze (escluso spese): <strong className="font-mono text-amber-300" data-testid="spettanze-previste">{formatEuro(totali)}</strong></span>
        </div>
      );
    }
  }
  return (
    <div className="mt-3 rounded-md border border-slate-700 bg-slate-900/40 px-3 py-2.5 text-sm text-slate-200" data-testid="spettanze-segnalatore">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider text-slate-400 mb-1">
        <HandCoins className="h-3.5 w-3.5 text-amber-500" /> Spettanze segnalatore {segnalatore} — solo informativo
      </div>
      {body}
    </div>
  );
};
